import React from 'react'
import { Row, Col, Container } from 'react-bootstrap'
import styled, { keyframes } from 'styled-components';
import { Link } from "gatsby"

class Hola extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            height: 0,
            width: 0
        }
    }

    updateDimensions = () => {
        if (this.state.height !== window.innerHeight) {
            this.setState({ height: window.innerHeight })
        }
        if (this.state.width !== window.innerWidth) {
            this.setState({ width: window.innerWidth })
        }
    }


    componentDidMount() {
        this.setState({ height: window.innerHeight, width: window.innerWidth })
        window.addEventListener('resize', this.updateDimensions)
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions)
    }

    render() {


        const glowAnimation = keyframes`
            0% { background-position: 0 0; }
            50% { background-position: 400% 0; }
            100% { background-position: 0 0; }
`


        const Section = styled.section`
            position: relative;            
            background-color: #fff;
            background-size: cover;
            background-repeat: no-repeat;
            @media (max-width:767px) {
                padding: 200px 0 200px 0;
            }
            @media (min-width:768px) and (max-width:1500px) {
                padding: 50px 0 150px 0;
            }
        `

        const Overlay = styled.div`
            width: 100%;
            display: flex;
            align-items: center;
            
        `

        const Heading1 = styled.h3`
            font-size: 40px;
            padding-top: 60px;
            font-family: "Montserrat", sans-serif;
            @media (max-width:767px) {
                font-size: 20px;
                line-height: 40px;
                margin-bottom: 300px;
            }           
        `

        const Heading2 = styled.h3`
            font-size: 40px;
            padding-top: 60px;
            font-family: "Montserrat", sans-serif;
            @media (max-width:767px) {
                font-size: 20px;
                line-height: 40px;
            }           
        `

        const Heading3 = styled.h3`
            font-size: 100px;
            font-family: Poppins;
            line-height: 40px;
            color: #000;
            font-weight: bold;
            margin: 40px 0 40px 0;            
            @media (min-width:768px) {
                margin-left: 4px;
            }
            @media (max-width:767px) {
                margin-left: 2px;
            }
            @media (min-width:768px) and (max-width:1500px) {
                font-size: 80px;
                margin: 40px 0 20px 0;
            }
            @media (max-width:767px) {
                font-size: 40px;
                line-height: 40px;
                margin-top: 180px;
            }
        `

        const Heading4 = styled.h4`
            font-size: 180px;
            color: #fff;
            font-weight: 700;
            text-transform: uppercase;
            padding-top: 20px;
            background: -webkit-linear-gradient(left, #c1eb18 , #65ff00);
            background: -o-linear-gradient(right, #c1eb18, #65ff00);
            background: -moz-linear-gradient(right, #c1eb18, #65ff00);
            background: linear-gradient(to right, #c1eb18, #65ff00); 
           -webkit-background-clip: text;
           -webkit-text-fill-color: transparent;
            @media (max-width:767px) {
                font-size: 80px;
                line-height: 80px;
            }
           @media (min-width:768px) and (max-width:1500px) {
                font-size: 130px;
            }
        `

        const Content = styled.div`
            position: relative;
            z-index: 10;
            text-align: center;            
        `

        const ResumeT = styled.a`
            width: 220px;
            padding: 10px;
            border: none;
            outline: none;
            color: #111;
            background: #fff;
            cursor: pointer;
            position: relative;
            z-index: 0;
            border-radius: 5px;
            border: 1px solid #000;
            &:before {
                content: '';
                background: linear-gradient(45deg, #ff0000, #ff7300, #fffb00, #48ff00, #00ffd5, #002bff, #7a00ff, #ff00c8, #ff0000);
                position: absolute;
                top: -2px;
                left:-2px;
                background-size: 400%;
                z-index: -1;
                filter: blur(5px);
                width: calc(100% + 4px);
                height: calc(100% + 4px);
                opacity: 0;
                transition: opacity .3s ease-in-out;
                border-radius: 5px;
                animation: ${glowAnimation} 20s linear infinite;    
            }
            &:hover {
                color: #000;
                border: none;
            }
            &:active {
                color: #000;
            }
            &:active:after {
                background: transparent;
            }
            &:hover:before {
                opacity: 1;
            }
            &:after {
                z-index: -1;
                content: '';
                position: absolute;
                width: 100%;
                height: 100%;
                background: #fff;
                left: 0;
                top: 0;
                border-radius: 5px;
            }
        `

        const Resume = styled(Link)`
            width: 220px;
            padding: 10px;
            border: none;
            outline: none;
            color: #111;
            background: #fff;
            cursor: pointer;
            position: relative;
            z-index: 0;
            border-radius: 5px;
            border: 1px solid #000;
            &:before {
                content: '';
                background: linear-gradient(45deg, #ff0000, #ff7300, #fffb00, #48ff00, #00ffd5, #002bff, #7a00ff, #ff00c8, #ff0000);
                position: absolute;
                top: -2px;
                left:-2px;
                background-size: 400%;
                z-index: -1;
                filter: blur(5px);
                width: calc(100% + 4px);
                height: calc(100% + 4px);
                opacity: 0;
                transition: opacity .3s ease-in-out;
                border-radius: 5px;
                animation: ${glowAnimation} 20s linear infinite;    
            }
            &:hover {
                color: #000;
                border: none;
            }
            &:active {
                color: #000;
            }
            &:active:after {
                background: transparent;
            }
            &:hover:before {
                opacity: 1;
            }
            &:after {
                z-index: -1;
                content: '';
                position: absolute;
                width: 100%;
                height: 100%;
                background: #fff;
                left: 0;
                top: 0;
                border-radius: 5px;
            }
        `



        return (
            <Section id="hola">
                <Overlay style={{ height: `${this.state.width > 500 ? this.state.height : 350}px` }}>
                    <Container>
                        <Content>
                            <Heading3>
                                No seas tímido(a)
                            </Heading3>
                            <Heading4>
                                ¡DI HOLA!
                            </Heading4>
                            <Row>
                                <Col md={6}>
                                    <Heading2>
                                        <ResumeT href="tel:+(57)3102767675"
                                            onClick={() => {
                                                window.gtag('event', 'click_button_llamenos', {
                                                    button_name: 'Llamenos',
                                                    destination_url: '+(57)3102767675'
                                                });
                                            }}>
                                            &nbsp;Llámenos&nbsp;
                                        </ResumeT>
                                    </Heading2>
                                </Col>
                                <Col md={6}>
                                    <Heading1>
                                        <Resume to="/conecta"
                                            onClick={() => {
                                                window.gtag('event', 'click_button_contacto', {
                                                    button_name: 'Contactenos',
                                                    destination_url: '/conecta'
                                                });
                                            }}>
                                            &nbsp;Contáctenos&nbsp;
                                        </Resume>
                                    </Heading1>
                                </Col>
                            </Row>
                        </Content>
                    </Container>
                </Overlay>
            </Section>
        )
    }
}

export default Hola